import { COMPONENT_TYPE } from '../pricing-constants';

const UpdatePricingWrapper = ({ componentType, children }) => {
    return componentType === COMPONENT_TYPE.UPDATE ? children : null;
};
export default UpdatePricingWrapper;
